import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

const ShowMappingDialog = ({ open, onClose, rowData }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <b>Associated Towns</b>
      </DialogTitle>
      <DialogContent>
        {rowData?.associated_towns?.length > 0 ? (
          <List>
            {rowData.associated_towns.map((town, index) => (
              <ListItem key={index} divider>
                <ListItemText
                  primary={
                    <Typography variant="subtitle1">
                      {town.municipality_name}
                    </Typography>
                  }
                  secondary={`Country: ${town.country__name} | State: ${town.state} | County: ${town.county}`}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography>No associated towns available.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShowMappingDialog;
